<template>
  <div class="simulation-results" v-if="this.simulation.set">
    <h4 class="simulation-results__title title--secondary" v-if="title">{{ title }}</h4>
    <ul v-if="showResults === 'All'" class="simulation-results__list grid">
      <li
        class="simulation-results__item"
        v-for="(insurer, index) in insurers"
        :key="`${insurer.id}_${index}`"
      >
        <figure v-if="insurer.value">
          <img
            :src="getInsurerImg(insurer.id)"
            :alt="`Logo ${insurer.id}`"
            class="simulation-results__logo"
            :data-id="insurer.id"
            @click="handleSelectedInsurer"
            loading="lazy"
          />
          <figcaption class="simulation-results__caption">
            <small
              :data-id="insurer.id"
              @click="handleSelectedInsurer"
              v-if="hasValue(insurer)"
            >R$ &nbsp;</small>
            <strong :data-id="insurer.id" @click="handleSelectedInsurer">
              {{
              hasValue(insurer)
              ? insurer.value.toFixed(2).replace(".",",").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
              : insurer.value
              }}
            </strong>
          </figcaption>
          <button
            v-if="hasValue(insurer)"
            type="button"
            class="simulation-results__button"
            :data-id="insurer.id"
            @click="handleSelectedInsurer"
            aria-label="Botão para selecionar seguradora"
          >Contrate agora!</button>
        </figure>
      </li>
    </ul>
    <ul v-if="showResults === 'Selected'" class="simulation-results__list">
      <li class="simulation-results__item">
        <figure>
          <img
            :src="getInsurerImg(this.quotation.user.financialData.selectedInsurer.id)"
            :alt="`Logo ${this.quotation.user.financialData.selectedInsurer.id}`"
            :data-id="this.quotation.user.financialData.selectedInsurer.id"
            @click="handleSelectedInsurer"
            class="simulation-results__logo"
            loading="lazy"
          />
          <figcaption class="simulation-results__caption">
            <small
              :data-id="this.quotation.user.financialData.selectedInsurer.id"
              @click="handleSelectedInsurer"
              v-if="typeof this.quotation.user.financialData.selectedInsurer.value == 'number'"
            >R$ &nbsp;</small>
            <strong
              :data-id="this.quotation.user.financialData.selectedInsurer.id"
              @click="handleSelectedInsurer"
            >
              {{
              typeof this.quotation.user.financialData.selectedInsurer.value == "number" && this.quotation.user.financialData.selectedInsurer.value
              ? this.quotation.user.financialData.selectedInsurer.value.toFixed(2).replace(".",",").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
              : this.quotation.user.financialData.selectedInsurer.value
              }}
            </strong>
          </figcaption>
          <button
            v-if="typeof this.quotation.user.financialData.selectedInsurer.value == 'number'"
            type="button"
            class="simulation-results__button"
            aria-label="Botão para abrir modal de troca de seguradora"
            @click="toogleChangeOptions"
          >Alterar seguradora</button>
        </figure>
      </li>
    </ul>
    <div v-if="openChangeInsurer" class="simulation-results__change-options-wrapper">
      <div class="simulation-results__change-options-content">
        <h4
          class="simulation-results__title title--secondary"
        >Selecione a seguradora para a qual deseja alterar</h4>
        <ul class="simulation-results__list">
          <li
            class="simulation-results__item"
            v-for="(insurer, index) in insurers"
            :key="`${insurer.id}_${index}`"
            @click="handleChangeSelectedInsurer"
          >
            <figure v-if="insurer.value">
              <img
                :src="getInsurerImg(insurer.id)"
                :alt="`Logo ${insurer.id}`"
                class="simulation-results__logo"
                loading="lazy"
              />
              <figcaption class="simulation-results__caption">
                <small
                  v-if="insurer.value && typeof insurer.value == 'number'"
                >{{insurer.value && "R$ &nbsp;"}}</small>
                <strong>
                  {{
                  (insurer.value && typeof insurer.value == "number") ? insurer.value.toFixed(2).replace(".",",").replace(/\B(?=(\d{3})+(?!\d))/g, ".") : insurer.value
                  }}
                </strong>
              </figcaption>
              <button
                v-if="typeof insurer.value == 'number'"
                type="button"
                class="simulation-results__button"
                :data-id="insurer.id"
                aria-label="Botão para selecionar seguradora"
              >Selecionar esta</button>
            </figure>
          </li>
        </ul>
        <button
          type="button"
          class="simulation-results__change-options-cancel"
          @click="toogleChangeOptions"
          aria-label="Botão para fechar modal de alteração de seguradora"
        >cancelar</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  name: "SimulationResults",
  props: {
    title: String,
    showResults: String // All or Selected
  },
  data() {
    return {
      openChangeInsurer: false,
      insurers: []
    };
  },
  computed: {
    ...mapState(["simulation", "quotation"]),
    ...mapGetters(["getInsurer", "getInsurers"])
  },
  methods: {
    ...mapActions(["setSelectedInsurer", "setQuotationStepIncrement"]),
    hasValue(insurer) {
      return insurer.value && typeof insurer.value == "number";
    },
    sortInsurers: function() {
      return this.getInsurers.list.sort((a, b) =>
        a.value > b.value ? 1 : a.value < b.value ? -1 : 0
      );
    },
    getInsurerImg: insurerId =>
      require(`../../assets/img/logo-${insurerId}.png`),
    handleSelectedInsurer: function({ target }) {
      const insurer = {
        id: target.dataset.id,
        name: this.getInsurer(target.dataset.id).name,
        logo: this.getInsurerImg(target.dataset.id),
        value: this.getInsurer(target.dataset.id).value
      };

      if (this.hasValue(insurer)) {
        this.setSelectedInsurer(insurer);
        // this.showResults === "All" && this.setQuotationStepIncrement() && this.$router.push("/cotacao/dados-pessoais");
        this.quotation.step === 0 && this.setQuotationStepIncrement() && this.$router.push("/cotacao/dados-pessoais");
      } else {
        return false;
      }
    },
    toogleChangeOptions: function() {
      this.openChangeInsurer = !this.openChangeInsurer;
      this.$emit("changeOptionsInsurer", this.openChangeInsurer);
    },
    handleChangeSelectedInsurer: function(event) {
      this.handleSelectedInsurer(event);
      this.toogleChangeOptions();
    }
  },
  mounted() {
    this.insurers = this.sortInsurers();
  },
  created() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === "updateSimulationValue") {
        this.insurers = this.sortInsurers();
      }
    });
  }
};
</script>

<style lang="scss">
.simulation-results {
  $this: &;
  @include fade-in(500ms);

  &__list {
    grid-template-columns: repeat(2, 1fr);
    grid-gap: $space__st;
    justify-items: center;
    align-items: center;

    @include breakpoint($tablet__min--sm) {
      grid-template-columns: repeat(4, 1fr);
    }
  }

  &__item {
    max-width: 200px;
    margin: 0 auto;
    figure {
      @extend %card;
      margin: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
  }

  &__logo {
    @include breakpoint($mobile__max--lg) {
      max-height: 70px;
    }
  }

  &__caption {
    display: flex;
    padding: $space__sm 0;
    justify-content: center;
    align-items: center;
    font-size: $font-size__lg;

    strong {
      &:only-child {
        text-align: center;
      }
    }
  }

  &__button {
    @extend %button__secondary;
    padding: $space__xs;

    @include breakpoint("max-width: 350px") {
      font-size: $font-size__sm;
    }

    @include breakpoint-range($tablet__min--sm, $tablet__max--lg) {
      max-width: 140px;
    }
  }
  &__change-options {
    &-content {
      position: relative;
      display: flex;
      margin-top: $space__lg;
      margin-right: -$space__st;
      margin-left: -$space__st;
      padding: $space__st;
      flex-direction: column;
      justify-content: space-evenly;
      align-items: center;
      background: $color__white;
      box-shadow: $shadow__modal;

      @include breakpoint($tablet__min--sm) {
        margin-right: 0;
        margin-left: 0;
      }

      &:before {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        left: 50%;
        width: $space__lg;
        height: $space__lg;
        background: $color__white;
        transform: translate(-50%, -20%) rotate(45deg);
        z-index: 1;
      }

      #{$this}__list {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-gap: $space__md;
        margin-bottom: $space__lg;

        @include breakpoint($tablet__min--sm) {
          grid-template-columns: repeat(4, 1fr);
        }
      }
    }

    &-cancel {
      @extend %button__terciary;

      @include breakpoint($tablet__min--sm) {
        max-width: 150px;
      }
    }
  }
}
</style>
